/**
* @name: header-bar-page
* @author: weiyong
* @date: 2023-05-11 18:24
* @description：header-bar-page
* @update: 2023-05-11 18:24
*/
<template>
  <header :class="[prefixCls,getHeaderClass]"
          class="el-header el-custom-header is-pageHeader el-txt"
          :style="'--el-custom-header-bg-color:'+getHeaderBgColor">
    <div class="header-left flex-div el-txt el-txt--h5" style="align-items: center">
      <SpaceSelItem  v-if="getShowSpaceSel&&isNotSystemOrGroup"/>
      <breadcrumb-container v-if="getShowBread"/>
      <!-- 面包屑-->
<!--      <LayoutBreadcrumb v-else v-if="getShowContent && getShowBread" :theme="getHeaderTheme"/>-->
    </div>


    <div class="header-right">
      <XmTenantDropdown />

      <AppLocalePicker class="icon-item"
                       :reload="true"
                       :showText="false"
      />


      <AppSearch :class="`${prefixCls}-action__item  icon-item`"/>
      <FullScreen :class="`${prefixCls}-action__item fullscreen-item  icon-item`"/>
      <!--      机构下拉-->
      <!--      <org-drop-down-sca class="icon-item no-right-padding" ></org-drop-down-sca>-->
      <!--用户下拉-->
      <user-drop-down-sca class="icon-item no-right-padding"/>

      <SettingDrawer
        v-if="getUserDefLayout !== false"
        :settingLayout="settingLayout"
        :class="[`${prefixCls}-action__item`,'icon-item','SettingDrawer']"
      />

      <UpdateLogIcon class="icon-item"/>
      <xm-icon-help class="icon-item" style="margin-left: 6px;"/>
    </div>
  </header>
</template>

<script lang="ts" setup>
import XmIconHelp from "@/layouts/default/header/components/xm-icon-help.vue";
import UpdateLogIcon from "@/layouts/default/header/components/UpdateLogIcon.vue";
import SpaceSelItem from '@/layouts/default/header/components/SpaceSelItem.vue';
import {AppLocalePicker} from '@/components/Application';
import UserDropDownSca from "@/layouts/layoutFrame/scaLayout/components/user-drop-down-sca.vue";
import {AppSearch} from "@/components/Application";
import FullScreen from "@/layouts/default/header/components/FullScreen.vue";
import BreadcrumbContainer
  from "@/layouts/layoutFrame/scaLayout/components/breadcrumb-container.vue";
import {useDesign} from "@/hooks/web/useDesign";
import {useHeaderSetting} from "@/hooks/setting/useHeaderSetting";
import {useRouter} from "vue-router";
import {computed, unref, watch} from "vue";
import {PageEnum} from "@/enums/pageEnum";
import {useRootSetting} from "@/hooks/setting/useRootSetting";
import { XmTenantDropdown } from '@/components/xm-tenant-and-industry-toggle'
import {createAsyncComponent} from "@/utils/factory/createAsyncComponent";
import GoingUtils from "@/utils/goingUtils";
import {useIsOperateHook} from "@/hooks/useIsOperateHook";

defineOptions({
  components: {
    SettingDrawer: createAsyncComponent(() => import('@/layouts/default/setting/index.vue'), {
      loading: true,
    }),
  },
  name: "header-bar-page",
});

const {prefixCls} = useDesign('scaLayout-header-bar-page');



const {
  getShowBread,
  getShowSpaceSel,
  getHeaderBgColor,
  getHeaderTheme,
} = useHeaderSetting();

const {isOerateUser}=useIsOperateHook();

const isNotSystemOrGroup = computed(()=>{
  //如果是运营平台 返回false
  if(isOerateUser){
    return  false;
  }
  return GoingUtils.isNotSystemOrGroup()
})

const {currentRoute} = useRouter();
const showHomeFlag = ref(true);

const props=defineProps({
  settingLayout:{
    type:Boolean,
    default:true
  }
})

watch(
  [() => currentRoute.value.path],
  () => {
    const route = unref(currentRoute);
    if (route.path === PageEnum.BASE_HOME_URL || route.path === '/') {
      showHomeFlag.value = true;
    } else {
      showHomeFlag.value = false;
    }
  }
);

/**
 * 获取header都主题颜色
 */
const getHeaderClass = computed(() => {
  const theme = unref(getHeaderTheme);
  return [
    prefixCls,
    {
      [`${prefixCls}--${theme}`]: theme,
    },
  ];
});

const { getUserDefLayout } = useRootSetting();
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-scaLayout-header-bar-page';
a {
  text-decoration: none
}

.@{prefix-cls} {
  .vben-layout-breadcrumb--dark .ant-breadcrumb-separator, .vben-layout-breadcrumb--dark .anticon {
    color: #333;
  }

  &.vben-scaLayout-header-bar-page.vben-scaLayout-header-bar-page--dark .el-txt--h5 .vben-SpaceSelItem.space-sel-item {
    & > .anticon{
      color: #FFF;
    }
    &:hover{
      color: #666;
      & > .anticon{
        color: #666;
      }
    }
    &.activeSpaceItem{
      color: #666;
      & > .anticon{
        color: #666;
      }
    }
  }
  &.vben-scaLayout-header-bar-page.el-custom-header{
    .icon{
      color: #FFF;
    }
  }

  .el-txt--h5 {
    .vben-SpaceSelItem.space-sel-item .label {
      font-family: var(--el-font-family);
      font-size: var(--el-h5-font-size);
      font-weight: var(--el-h5-font-weight);
      display: inline-block;
      padding-left: 4px;
    }

    .vben-SpaceSelItem.space-sel-item > .anticon {
      font-size: 22px;
      display: inline-block;
      padding-right: 8px;
      color: var(--primary-color, #0a6eff)
    }

    .vben-layout-breadcrumb--light .ant-breadcrumb-link a,
    .vben-layout-breadcrumb--dark .ant-breadcrumb-link a {
      color: #333;
      font-family: var(--el-font-family);
      font-size: var(--el-h5-font-size);
      font-weight: var(--el-h5-font-weight);
      line-height: var(--el-h5-line-height);
      letter-spacing: var(--el-h5-letter-spacing);

      &:hover {
        text-decoration: none
      }
    }

    .vben-layout-breadcrumb--light .ant-breadcrumb-link,
    .vben-layout-breadcrumb--dark .ant-breadcrumb-link {
      color: #333;
      font-family: var(--el-font-family);
      font-size: var(--el-h5-font-size);
      font-weight: var(--el-h5-font-weight);
      line-height: var(--el-h5-line-height);
      letter-spacing: var(--el-h5-letter-spacing);

      .icon-span-breadcrumb {
        display: inline-block;
        padding-right: 5px;
      }

      .remix-icon {
        font-size: 22px;
        color: var(--primary-color, #0a6eff);
      }
    }
  }

  &.el-custom-header {
    height: 73px;
    background-color: var(--el-custom-header-bg-color);
    padding: 0 20px;
    display: flex;
    gap: 24px;
    align-items: center;
    position: -webkit-sticky;
    position: sticky;
    justify-content: space-between;
    top: 0;
    width: 100%;
    box-sizing: border-box;
    z-index: 100;
    border-bottom: 1px solid var(--el-color-primary-dark-2);

    .icon {
      color: var(--primary-color, #0a6eff);
      vertical-align: middle;
      margin: 6px 0;
      font-size: 20px;
    }
  }

  .breadcrumb-container {
    height: 32px;
    display: inline-flex;
    align-items: center;
    .el-txt.el-txt--h5{
      padding: 0 18px;
    }
  }

  .svg-inline--fa {
    display: var(--fa-display, inline-block);
    height: 1em;
    overflow: visible;
    vertical-align: -0.125em;
  }

  .el-txt.el-txt--h5 {
    font-family: var(--el-font-family);
    font-size: var(--el-h5-font-size);
    font-weight: var(--el-h5-font-weight);
    line-height: var(--el-h5-line-height);
    letter-spacing: var(--el-h5-letter-spacing);
    color: var(--el-text-color-primary, #303133);
  }

  .header-right {
    align-items: center;
    display: flex;

    .icon-item {
      color: var(--el-text-color-primary, #0a001f);
      display: inline-block;
      padding: 0 10px;

      &.no-right-padding {
        padding-right: 0;
      }
    }

  }

  .fullscreen-item {
    cursor: pointer;
  }

}
</style>
